import { GTM_NOTSET_INTEGER, GTM_NOTSET_STRING, getGtmAttr } from '@musinsa/frontend-utils';
import type { BaseProductImageItem } from '../components/variants/BaseProductImageItem';

type SelectItemGtmSource = BaseProductImageItem & {
  brandName?: string | null;
  price?: number | null;
  salesRate?: number | null;
  normalPrice?: number | null;
  originalPrice?: number | null;
  couponPrice?: number | null;
};

const getOriginalPrice = (item: SelectItemGtmSource): number | null | undefined => {
  if ('normalPrice' in item) return item.normalPrice;
  if ('originalPrice' in item) return item.originalPrice;
  return null;
};

const getCouponPrice = (item: SelectItemGtmSource): number | null | undefined => {
  if ('couponPrice' in item) return item.couponPrice;
  return null;
};

export const buildSelectItemGtmAttr = (item: SelectItemGtmSource, index: number) => {
  const originalPrice = getOriginalPrice(item);
  const couponPrice = getCouponPrice(item);

  return getGtmAttr(['select_item', 'view_item_list'], {
    discount:
      originalPrice != null && item.price != null ? originalPrice - item.price : GTM_NOTSET_INTEGER,
    discount_rate: item.salesRate?.toString() ?? GTM_NOTSET_STRING,
    item_brand: item.brandName ?? GTM_NOTSET_STRING,
    item_category: GTM_NOTSET_STRING,
    item_id: String(item.goodsNo),
    item_list_id: GTM_NOTSET_STRING,
    item_list_index: String(index),
    original_price: originalPrice ?? GTM_NOTSET_INTEGER,
    price: item.price ?? GTM_NOTSET_INTEGER,
    quantity: 1,
    ...(couponPrice != null ? { best_price: couponPrice } : {}),
  });
};
